/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    numberOfTrips: {
        id: 'quoteandbind.RecMarLinedirectives.templates.ExtNavigation.Number Of Trips',
        defaultMessage: 'Number Of Trips'
    },
    extensionPeriod: {
        id: 'quoteandbind.RecMarLinedirectives.templates.ExtNavigation.Extension Period',
        defaultMessage: 'Extension Period'
    },
    navigationalLimit: {
        id: 'quoteandbind.RecMarLinedirectives.templates.ExtNavigation.Navigational Limit',
        defaultMessage: 'Navigational Limit'
    },
    deductible: {
        id: 'quoteandbind.RecMarLinedirectives.templates.ExtNavigation.Deductible (%)',
        defaultMessage: 'Deductible (%)'
    },
    minimumDeductible: {
        id: 'quoteandbind.RecMarLinedirectives.templates.ExtNavigation.Minimum Deductible ($)',
        defaultMessage: 'Minimum Deductible ($)'
    }
});